import { render, staticRenderFns } from "./projetoexterno.vue?vue&type=template&id=a53369da&"
import script from "./projetoexterno.vue?vue&type=script&lang=js&"
export * from "./projetoexterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports